/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_IntroInputs */

const en_svc_research_intro = /** @type {(inputs: Svc_Research_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We build AI research agents that gather, compare and check information, from the web and from your own records, and hand back a brief where every claim links to its source. You read the brief; the agent did the searching.`)
};

const lv_svc_research_intro = /** @type {(inputs: Svc_Research_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izstrādājam AI izpētes aģentus, kas savāc, salīdzina un pārbauda informāciju no interneta un Jūsu ierakstiem un nodod kopsavilkumu, kurā katrs apgalvojums norāda uz avotu. Jūs lasāt kopsavilkumu, meklēšanu paveica aģents.`)
};

/**
* | output |
* | --- |
* | "We build AI research agents that gather, compare and check information, from the web and from your own records, and hand back a brief where every claim links..." |
*
* @param {Svc_Research_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_intro = /** @type {((inputs?: Svc_Research_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_intro(inputs)
	return en_svc_research_intro(inputs)
});